var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-wrapper"},[_c('div',{staticClass:"content"},[_c('img',{attrs:{"src":"https://files.jinr.com/jinr-index/img/m-jinr-banner.png","alt":"","srcset":""}})])])
}]

export { render, staticRenderFns }